export const enum ViewConstants {
  assignmentsView = 'assignmentsView',
  personalPanel = 'personalPanel',
  storiesView = 'storiesView',
  weekView = 'weekView',
}
